import { DtIconCalendarClock as c, DtIconLaptop2 as r, DtIconAtSign as a, DtIconHashBold as l, DtIconLockFilled as i, DtIconExternalLink as s, DtIconUsers as C, DtIconSparkle as p, DtIconLock as I, DtIconLayoutTemplate as _, DtIconThread as D, DtIconHash as T, DtIconContacts as d, DtIconInbox as E, DtIconDialbot as u } from "@dialpad/dialtone-icons/vue3";
import { LEFTBAR_GENERAL_ROW_CONTACT_CENTER_COLORS as A, LEFTBAR_GENERAL_ROW_TYPES as e } from "./general-row-constants.js";
import { resolveComponent as y, createBlock as L, createElementBlock as o, createCommentVNode as R, openBlock as n, resolveDynamicComponent as f, normalizeClass as O, createVNode as S } from "vue";
import { _ as h } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const k = /* @__PURE__ */ new Map([
  [e.INBOX, E],
  [e.CONTACTS, d],
  [e.CHANNELS, T],
  [e.THREADS, D],
  [e.LAUNCHPAD, _],
  [e.LOCKED_CHANNEL, I],
  [e.QUICK_START, p],
  [e.COACHING_GROUP, C],
  [e.COACHING_CENTER, s],
  ["locked channel unread", i],
  ["channel unread", l],
  [e.ASSIGNED, a],
  [e.DIGITAL, r],
  [e.SCHEDULED, c]
]), b = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeLeftbarGeneralRowIcon",
  components: {
    DtIconDialbot: u,
    DtIconInbox: E,
    DtIconContacts: d,
    DtIconHash: T,
    DtIconThread: D,
    DtIconLayoutTemplate: _,
    DtIconLock: I,
    DtIconSparkle: p,
    DtIconUsers: C,
    DtIconExternalLink: s,
    DtIconLockFilled: i,
    DtIconHashBold: l,
    DtIconAtSign: a,
    DtIconLaptop2: r,
    DtIconCalendarClock: c
  },
  props: {
    type: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    iconSize: {
      type: String,
      default: "300"
    }
  },
  computed: {
    isIconType() {
      return ![e.DIALBOT, e.CONTACT_CENTER].includes(this.type);
    },
    isContactCenterType() {
      return this.type === e.CONTACT_CENTER;
    },
    isDialbotType() {
      return this.type === e.DIALBOT;
    },
    getIconName() {
      return k.get(this.type);
    },
    contactCenterIconClasses() {
      return [
        "d-recipe-leftbar-row__icon-cc",
        A[this.color]
      ];
    }
  }
}, g = {
  key: 2,
  class: "d-recipe-leftbar-general-row__icon",
  "data-qa": "general-row-dialbot"
};
function B(G, H, m, w, z, t) {
  const N = y("dt-icon-dialbot");
  return t.isIconType ? (n(), L(f(t.getIconName), {
    key: 0,
    size: m.iconSize
  }, null, 8, ["size"])) : t.isContactCenterType ? (n(), o("div", {
    key: 1,
    class: O(t.contactCenterIconClasses)
  }, null, 2)) : t.isDialbotType ? (n(), o("div", g, [
    S(N, { size: "500" })
  ])) : R("", !0);
}
const P = /* @__PURE__ */ h(b, [["render", B]]);
export {
  P as default
};
//# sourceMappingURL=leftbar-general-row-icon.js.map
